angular.module('salesPath2.spd')
.factory('spdTmpRisks', [function() {

    /*
     * Dopisane "recznie" atrybuty na skutek braku SPD - do udekorowania w docelowej aplikacji
     */
    var risks = {};
    return risks;
  }])
;